
export enum BrokerKey {

    TF = "TF",
    GE = "GE",
    GE2 = "GE2",
    PULSE = "PULSE",
    PHILLIP = "PHILLIP",
    MORGANS = "MORGANS",
    APPS = "APPS",
    ETRADE = "ETRADE",
    D2MX = "D2MX",
    NOVUS = "NOVUS",
    OPEN_MARKETS = "OPEN_MARKETS",
    OPEN_TRADER = "OPEN_TRADER",
    BELLMONT = "BELLMONT",
    FUTURE_ASSIST = "FUTURE_ASSIST",
    ALLFIN = "ALLFIN",
    LIQUIDITY = "LIQUIDITY",
    AUSIEX = "AUSIEX",
    PERSHING = "PERSHING",

    VFS = "VFS",
    SHAW = "SHAW",

    BELL = "BELL",
    COMMSEC = "COMMSEC",
    BURRELL = "BURRELL",
    ORD = "ORD",
    MACQUARIE = "MACQUARIE",
    EVANS = "EVANS",
    BAKER = "BAKER",
    WILSONS = "WILSONS",
    SENTINEL = "SENTINEL",
    ARGO = "ARGO",
    DJ = "DJ",

    TRADEON = "TRADEON",
    IV = "IV",
    IV_D2MX = "IV_D2MX",
    IV_PHILLIP = "IV_PHILLIP",
    MORRISON = "MORRISON",

    GAME = "GAME",

    MM = "MM"
}
